"use client";
import * as React from "react";
const SvgBoltRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 9 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M3.3 16a.515.515 0 0 1-.513-.587l.81-5.635H.447c-.792 0-.297-.667-.279-.694C1.303 7.102 3.003 4.17 5.252.258c.09-.16.27-.258.45-.258.314 0 .557.276.512.587l-.81 5.635h3.158c.36 0 .558.17.36.587-2.96 5.102-4.678 8.08-5.173 8.933A.512.512 0 0 1 3.3 16Z" }));
export {
  SvgBoltRound as default
};
